function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "single-01",
  transform: "translate(-1.4 -0.4)"
}, React.createElement("path", {
  id: "Path_441",
  "data-name": "Path 441",
  d: "M9.875,8.125h0A3.074,3.074,0,0,1,7,4.887V4.239A3.074,3.074,0,0,1,9.875,1h0A3.074,3.074,0,0,1,12.75,4.239v.648A3.074,3.074,0,0,1,9.875,8.125Z",
  transform: "translate(-1.375)",
  fill: "none",
  stroke: "rgba(0,0,0,0.65)",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 1.2
}), React.createElement("path", {
  id: "Path_442",
  "data-name": "Path 442",
  d: "M15,19.179a2.586,2.586,0,0,0-1.907-2.5A18.09,18.09,0,0,0,8.5,16a18.09,18.09,0,0,0-4.593.681A2.586,2.586,0,0,0,2,19.179v1.355H15Z",
  transform: "translate(0 -5.534)",
  fill: "none",
  stroke: "rgba(0,0,0,0.65)",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 1.2
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 14.2,
    height: 15.2,
    viewBox: "0 0 14.2 15.2",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.6e4fd3da.svg";
export { ForwardRef as ReactComponent };